var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75293,
    width: 24.7888,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3908 7.48668C18.3175 7.38001 17.2442 7.30001 16.1642 7.24001V7.23334L16.0175 6.36668C15.9175 5.75334 15.7708 4.83334 14.2108 4.83334H12.4642C10.9108 4.83334 10.7642 5.71334 10.6575 6.36001L10.5175 7.21334C9.89751 7.25334 9.27751 7.29334 8.65751 7.35334L7.29751 7.48668C7.01751 7.51334 6.81751 7.76001 6.84418 8.03334C6.87085 8.30668 7.11085 8.50668 7.39085 8.48001L8.75085 8.34668C12.2442 8.00001 15.7642 8.13334 19.2975 8.48668C19.3175 8.48668 19.3308 8.48668 19.3508 8.48668C19.6042 8.48668 19.8242 8.29334 19.8508 8.03334C19.8708 7.76001 19.6708 7.51334 19.3908 7.48668Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1649 9.42675C18.0049 9.26008 17.7849 9.16675 17.5582 9.16675H9.13155C8.90489 9.16675 8.67822 9.26008 8.52489 9.42675C8.37155 9.59341 8.28489 9.82008 8.29822 10.0534L8.71155 16.8934C8.78489 17.9067 8.87822 19.1734 11.2049 19.1734H15.4849C17.8116 19.1734 17.9049 17.9134 17.9782 16.8934L18.3916 10.0601C18.4049 9.82008 18.3182 9.59341 18.1649 9.42675ZM14.4516 15.8334H12.2316C11.9582 15.8334 11.7316 15.6067 11.7316 15.3334C11.7316 15.0601 11.9582 14.8334 12.2316 14.8334H14.4516C14.7249 14.8334 14.9516 15.0601 14.9516 15.3334C14.9516 15.6067 14.7249 15.8334 14.4516 15.8334ZM15.0116 13.1667H11.6782C11.4049 13.1667 11.1782 12.9401 11.1782 12.6667C11.1782 12.3934 11.4049 12.1667 11.6782 12.1667H15.0116C15.2849 12.1667 15.5116 12.3934 15.5116 12.6667C15.5116 12.9401 15.2849 13.1667 15.0116 13.1667Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ab7548630fd90df3a2471e91011d3781.svg";
export { ForwardRef as ReactComponent };